import apiClient from './api';

const base = (restaurantId, id) =>
  `/users/restaurant/${restaurantId}/locations/${id ? `${id}/` : ''}`;

export const locationsService = {
  list: async (restaurantId, { includeInactive = false } = {}) => {
    const { data } = await apiClient.get(base(restaurantId), {
      params: includeInactive ? { include_inactive: 'true' } : {},
    });
    return data?.results || [];
  },
  /** Like list(), but also returns which branch the public website speaks for. */
  listWithSiteBranch: async (restaurantId, { includeInactive = false } = {}) => {
    const { data } = await apiClient.get(base(restaurantId), {
      params: includeInactive ? { include_inactive: 'true' } : {},
    });
    return {
      locations: data?.results || [],
      publicSiteLocationId: data?.public_site_location_id ?? null,
    };
  },

  /** Point the public website at one branch; null unassigns it back to visitor-picked outlets. */
  setPublicSiteLocation: async (restaurantId, locationId) => {
    const { data } = await apiClient.put(
      `/users/restaurant/${restaurantId}/public-site-location/`,
      { location_id: locationId },
    );
    return data?.public_site_location_id ?? null;
  },

  get: async (restaurantId, id) => {
    const { data } = await apiClient.get(base(restaurantId, id));
    return data?.data;
  },
  create: async (restaurantId, payload) => {
    const { data } = await apiClient.post(base(restaurantId), payload);
    return data?.data;
  },
  update: async (restaurantId, id, payload) => {
    const { data } = await apiClient.put(base(restaurantId, id), payload);
    return data?.data;
  },
  remove: async (restaurantId, id) => {
    const { data } = await apiClient.delete(base(restaurantId, id));
    return data;
  },

  // ----- Location admins (staff mapped to a location) ----- //
  listAdmins: async (restaurantId, locationId) => {
    const { data } = await apiClient.get(`${base(restaurantId, locationId)}admins/`);
    return data?.results || [];
  },
  addAdmin: async (restaurantId, locationId, staffId) => {
    const { data } = await apiClient.post(`${base(restaurantId, locationId)}admins/`, { staff_id: staffId });
    return data?.data || [];
  },
  removeAdmin: async (restaurantId, locationId, staffId) => {
    const { data } = await apiClient.delete(`${base(restaurantId, locationId)}admins/${staffId}/`);
    return data;
  },
};
